"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertEmptyValuesToNull = exports.filterEmptyFormValues = exports.castFormValues = void 0;
var castFormValues = function (values, casts) {
    var castKeys = Object.keys(casts);
    var result = __assign({}, values);
    castKeys.forEach(function (key) {
        var type = casts[key];
        if (!result.hasOwnProperty(key)) {
            return;
        }
        if ('int' === type) {
            result[key] = parseInt(result[key], 10);
        }
        if ('string' === type) {
            result[key] = result[key].toString();
        }
        if ('boolean' === type) {
            result[key] = 'true' === result[key] || '1' === result[key];
        }
    });
    return result;
};
exports.castFormValues = castFormValues;
var filterEmptyFormValues = function (values) {
    var result = __assign({}, values);
    var keys = Object.keys(result);
    keys.forEach(function (key) {
        if ('' === result[key]) {
            delete result[key];
        }
    });
    return __assign({}, result);
};
exports.filterEmptyFormValues = filterEmptyFormValues;
var convertEmptyValuesToNull = function (values) {
    var result = __assign({}, values);
    var keys = Object.keys(result);
    keys.forEach(function (key) {
        if ('' === result[key]) {
            result[key] = null;
        }
    });
    return __assign({}, result);
};
exports.convertEmptyValuesToNull = convertEmptyValuesToNull;
